import React, { useState, useRef } from "react";
import { API_URL } from "../helpers";
import "./styles.css";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const FriendsSigin = () => {
  const [names, setNames] = useState({});
  const [errors, setErrors] = useState([]);
  const [msg, setMsg] = useState({});

  const formElement = useRef(null);

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/friendsSignin`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "remember") {
        data.append(key, value ? "1" : "0");
      } else {
        data.append(key, value);
      }
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        formElement.current.reset();
        setNames({});
        setMsg({
          type: "success",
          text: json.text,
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div id="full-column">
      <Hdg section="Friendraising" />
      <>
        {alert.type ? (
          <Alert data={alert} />
        ) : (
          <>
            <h3>
              <i className="fa fa-sign-in" /> &nbsp;Account Sign In
            </h3>

            <p>
              If you previsoulsy have created a “friendraiser” account, please
              enter your email address below and we will email you your access
              link.
            </p>

            <p style={{ marginBottom: "15px" }}>
              Should you have any questions, please contact{" "}
              <a href="mailto:stephanie@valerotexasopen.com">
                Stephanie@ValeroTexasOpen.com
              </a>{" "}
              or at 210.345.3839.
            </p>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <h3 style={{ marginTop: "0" }}>Account Information</h3>

              <div className="form-group" style={{ marginBottom: "10px" }}>
                <Input
                  name="email"
                  label="Email Address"
                  reqd={true}
                  value={names.email || ""}
                  update={handleUpdate}
                  errors={errors}
                />
                <div className="empty" />
              </div>

              <div className="form-group checkbox" style={{ marginTop: "0" }}>
                <Checkbox
                  name="remember"
                  label="Check to remember my sign in on this device"
                  checked={false}
                  click={handleUpdate}
                />
              </div>

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit
                    path="/friends/signup"
                    left="Create Account"
                    submit="Sign In"
                  />
                </div>
              </div>
            </form>
          </>
        )}
      </>
    </div>
  );
};

export default FriendsSigin;
